// ImageVariable.ts
import { Node, mergeAttributes } from "@tiptap/core";

export interface DocumentImageOptions {
    HTMLAttributes: Record<string, any>;
}

export const DocumentImage = Node.create<DocumentImageOptions>({
    name: "documentImage",
    group: "inline",
    inline: true,
    atom: true,
    selectable: true,
    draggable: false,

    addAttributes() {
        return {
            name: { default: null },
            label: { default: null },
            src: { default: null },
            alt: { default: null },
            "data-image-id": { default: null },
        };
    },

    parseHTML() {
        return [
            {
                tag: "img[data-image-id]",
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return [
            "img",
            mergeAttributes(
                {
                    class: "document-image",
                    src: HTMLAttributes.src ?? "",
                    alt: HTMLAttributes.alt ?? HTMLAttributes.label ?? "",
                    width: HTMLAttributes.width ?? "auto",
                    height: HTMLAttributes.height ?? "auto",
                    "data-image-id": HTMLAttributes.imageId ?? "",
                    contenteditable: "false",
                },
                HTMLAttributes
            ),
        ];
    },
});
